export default {
  state: {
    itemId: "",
    applicationType: "",
  },
};
